// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iLZa","index":"styles_index__1Gl6X"};